import React, { useState } from "react";
import Button from "shared/ui/Button";
import Input from "shared/ui/Input";
import s from "./style.module.scss";
import { RegistrationFormProps } from "./types";
import { RegistrationApi } from "../api";
import { formatPhone } from "shared/lib/formatPhone";
import { useAppDispatch } from "shared/redux/hooks";
import { showError } from "shared/lib/showError";
import { setContent, setOpen } from "shared/redux/reducers/PopupSlice";
import Error from "shared/ui/Error";

const RegistrationForm: React.FC<RegistrationFormProps> = ({
  phone,
  setCodeSent,
  setPhone,
  setHaveCode,
}) => {
  const dispatch = useAppDispatch();
  const [dataSending, setDataSending] = useState(false);

  const buttonDisabled = dataSending || phone.trim() === "" || phone === "+7(";

  const handleSubmit = () => {
    setDataSending(true);

    RegistrationApi({ confirm: 1, msisdn: formatPhone(phone) })
      .then((res) => {
        setCodeSent(true);
      })
      .catch((e) => {
        showError(e, dispatch);
      })
      .finally(() => setDataSending(false));
  };

  const handleHaveCode = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (phone.trim() === "" || phone === "+7(" || phone.length < 16) {
      dispatch(setOpen(true));
      dispatch(setContent(<Error text="Введите номер телефона" />));
      return;
    }

    setHaveCode(true);
  };

  return (
    <form className={s.form}>
      <p>Введите номер телефона и мы отправим вам код</p>

      <Input
        className={s.input}
        setValue={setPhone}
        value={phone}
        mask={"+{7}(000)000-00-00"}
      />

      <Button
        disabled={buttonDisabled}
        className={s.button}
        onClick={handleSubmit}
      >
        Зарегистрироваться
      </Button>

      <button onClick={handleHaveCode} className={s.have_code}>
        У меня уже есть код
      </button>
    </form>
  );
};

export default RegistrationForm;
